import { INITIAL_REWARDS_DATA } from "@constants/common";
import { Card, Typography } from "@kelp-dao/kernel-design-system";
import { useCallback } from "react";
import { numberToCurrency } from "utils";
import { RewardChipProps } from "./types";
import BaseImage from "@components/BaseImage";

const isTrueValue = (value: string | undefined) => {
  return value && Number(value);
};

export const Reward = ({ row, dashboardData }: RewardChipProps) => {
  console.log(row);
  console.log(dashboardData);
  const getValue = useCallback(
    (key: string | null, isComingSoon: boolean) => {
      if (key === null) return "-";

      if (
        dashboardData &&
        dashboardData[key as keyof typeof INITIAL_REWARDS_DATA]
      ) {
        return numberToCurrency(
          (
            +dashboardData[key as keyof typeof INITIAL_REWARDS_DATA] / 1000
          ).toFixed(4)
        );
      } else if (isComingSoon) {
        return (
          <Typography type="heading" variant="xxsmall">
            {key}
          </Typography>
        );
      }
      return "-";
    },
    [dashboardData]
  );

  return (row.kelpKey || row.elpKey) &&
    dashboardData &&
    (isTrueValue(
      dashboardData[row.kelpKey as keyof typeof INITIAL_REWARDS_DATA]
    ) ||
      isTrueValue(
        dashboardData[row.elpKey as keyof typeof INITIAL_REWARDS_DATA]
      )) ? (
    <Card
      variant="bordered"
      key={row.title}
      className="flex items-center gap-3 px-0 md:px-4 py-3 border-none md:!border-[1px] md:!border-solid md:!border-border-default"
    >
      <div className="w-6 h-6 rounded-full border border-[#CCE5E5] flex items-center justify-center">
        <BaseImage
          height={16}
          width={16}
          alt="platform"
          src={row.icon}
          objectFit="cover"
        />
      </div>

      <div className="flex flex-col">
        <Typography
          type="body"
          variant="medium"
          className="font-medium leading-5"
        >
          {getValue(row.kelpKey, row.isComingSoon)}
        </Typography>
        <Typography
          type="heading"
          variant="xsmall"
          className="text-text-secondary font-normal text-[12px] font-sans"
        >
          Kernal Points
        </Typography>
      </div>
    </Card>
  ) : null;
};
